import SvgIcon from "@mui/material/SvgIcon";

export default function HandScanIcon(props) {
  return (
    <SvgIcon
      sx={{
        fontSize: 48,
        marginTop: "-21px",
        marginBottom: "-3px",
        verticalAlign: "middle",
      }}
      {...props}
      viewBox="0 0 256 256"
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth={10}
        strokeLinecap="round"
        d="M40 60c-28 32-28 104 0 136"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth={10}
        strokeLinecap="round"
        d="M72 84c-18 22-18 66 0 88"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth={10}
        strokeLinecap="round"
        d="M216 60c28 32 28 104 0 136"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth={10}
        strokeLinecap="round"
        d="M184 84c18 22 18 66 0 88"
      />
      <g transform="translate(128 128) scale(0.5) translate(-128 -128)">
        <path
          fill="currentColor"
          d="M136 168a8 8 0 1 1-8-8a8 8 0 0 1 8 8m76-52v36a84 84 0 0 1-168 0V76a24 24 0 0 1 40-17.87V44a24 24 0 0 1 47.93-1.8A24 24 0 0 1 172 60v38.13A24 24 0 0 1 212 116m-8 0a16 16 0 0 0-32 0v4a4 4 0 0 1-8 0V60a16 16 0 0 0-32 0v44a4 4 0 0 1-8 0V44a16 16 0 0 0-32 0v68a4 4 0 0 1-8 0V76a16 16 0 0 0-32 0v76a76 76 0 0 0 152 0Zm-24.42 50.21a4 4 0 0 1 0 3.58c-.7 1.4-17.5 34.21-51.58 34.21s-50.88-32.81-51.58-34.21a4 4 0 0 1 0-3.58c.7-1.4 17.5-34.21 51.58-34.21s50.88 32.81 51.58 34.21m-8.16 1.8c-3.83-6.43-18.55-28-43.42-28s-39.6 21.55-43.42 28c3.84 6.44 18.55 28 43.42 28s39.6-21.56 43.42-28.01Z"
        />
      </g>
    </SvgIcon>
  );
}
